import moment from 'moment';
import StripePlan from '@/datatypes/stripe/plan';

export default class StripeSubscription {
  public id: string;
  public billing: string;
  public currentPeriodStart: number;
  public currentPeriodEnd: number;
  public currentPeriodStartDate: undefined | Date;
  public currentPeriodEndDate: undefined | Date;
  public status: string;
  public subscriptionStartedAt: undefined | Date;
  public endedAt: number;
  public plan: StripePlan;

  constructor(options) {
    this.id = options.id;
    this.billing = options.billing;
    this.currentPeriodStart = options.currentPeriodStart;
    this.currentPeriodEnd = options.currentPeriodEnd;
    if (options.currentPeriodStart) {
      this.currentPeriodStartDate = moment(options.currentPeriodStart).toDate();
    }
    if (options.currentPeriodEnd) {
      this.currentPeriodEndDate = moment(options.currentPeriodEnd).toDate();
    }
    this.status = options.status;
    if (options.subscriptionStartedAt) {
      this.subscriptionStartedAt = moment(options.subscriptionStartedAt).toDate();
    }
    this.endedAt = options.endedAt;
    if (typeof options.plan !== 'undefined') {
      this.plan = new StripePlan(options.plan);
    } else {
      this.plan = new StripePlan({});
    }
  }
}
